'use strict';

var jsxRuntime = require('react/jsx-runtime');
var material = require('@mui/material');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const DefaultSelectField = (_param)=>{
    var { options = [], SelectProps: maybeSelectProps } = _param, props = _object_without_properties_loose(_param, [
        "options",
        "SelectProps"
    ]);
    const selectProps = _extends({}, maybeSelectProps);
    const isNative = !!selectProps.native;
    return /*#__PURE__*/ jsxRuntime.jsx(material.TextField, _extends({
        variant: "outlined",
        value: "",
        select: true,
        SelectProps: selectProps,
        fullWidth: true
    }, props, {
        children: options == null ? void 0 : options.map(({ value, label })=>isNative ? /*#__PURE__*/ jsxRuntime.jsx("option", {
                value: value != null ? value : '',
                children: label
            }, value) : /*#__PURE__*/ jsxRuntime.jsx(material.MenuItem, {
                value: value != null ? value : '',
                children: label
            }, value))
    }));
};

exports.DefaultSelectField = DefaultSelectField;
